export enum OutgoingInvoiceCreationTypeEnum {
  CONSOLIDATED = 'consolidated',
  SINGLE = 'single',
}
